export default import.meta.ROLLDOWN_FILE_URL_2EheqdQWt4TZr0ndEQR38Q